// extracted by mini-css-extract-plugin
module.exports = {"bodyTitle":"NolBottomSheet_bodyTitle__3dCmE","bodyDescription":"NolBottomSheet_bodyDescription__1RANE","bodyContainer":"NolBottomSheet_bodyContainer__vCL_5"};